import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Image from '../components/image'
import {AnimatedBox} from '../elements'
import {config, useSpring} from 'react-spring'

const IndexPage = () => {
  const pageAnimation = useSpring({
    config: config.slow,
    from: {opacity: 0},
    to: {opacity: 1},
  })
  return (
    <Layout>
      <AnimatedBox
        style={pageAnimation}
        py={[6, 6, 6, 8]}
        px={[6, 6, 8, 6, 8, 13]}
      >
        <SEO title="Home" />
        <h1>Hi people!</h1>
        <p>Welcome to your new Kino as a Service store.</p>
        <Image />
      </AnimatedBox>
    </Layout>
  )
}

export default IndexPage
